module.exports = __webpack_public_path__ + "img/electronic_use.c2e8af58.svg";